module.exports = __webpack_public_path__ + "static/img/application2.44bc3da9.png";